import { t } from "@/i18n-js/instance";
import { formatPaywallCurrencyAmount } from "@circle-react/helpers/paywalls/currencies";
import type { PaywallCheckoutPreview } from "@circle-react/types";
import { DefaultFullPreview } from "../../../";
import type { CheckoutPreviewEntryProps } from "../../../components/PreviewEntry";
import type { ComponentLineProps } from "../../FirstPaymentPreview/types";
import { reducer } from "../helpers";

const buildOptions = (
  preview: PaywallCheckoutPreview,
): Partial<CheckoutPreviewEntryProps> => {
  const results = preview.remaining_payments?.installments_preview.reduce(
    reducer,
    {
      discounted: {
        quantity: 0,
        singleInstallmentAmountDue: 0,
        totalAmountDue: 0,
      },
    },
  );

  if (!results?.discounted || results?.discounted.quantity === 0) {
    return { hide: true };
  }

  const valueFormatted = formatPaywallCurrencyAmount(
    preview.currency,
    results?.discounted.singleInstallmentAmountDue || 0,
  );

  return {
    label: t(
      [
        "paywall_checkout.future_payments.discounted_installments",
        preview.paywall_price.interval_type,
      ],
      {
        count: results?.discounted.quantity,
      },
    ),
    value: `${results?.discounted.quantity}x ${valueFormatted}`,
  };
};

export const DiscountedInstallmentsLine = ({
  preview,
}: Pick<ComponentLineProps, "preview">) => {
  const options = buildOptions(preview);
  return <DefaultFullPreview.PreviewEntry label="" {...options} />;
};
